<template>
	<div class="home" id="clasdaa">
		<!-- <scroller 
      :on-refresh="refresh"
      :on-infinite="infinite" style="height:2rem;" refresh-layer-color="red" loading-layer-color="red">   </scroller> -->
		<!-- <scroller :on-infinite="infinite" ref="myscroller"></scroller> -->
		<vue-waterfall-easy ref="waterfall" :imgsArr="goddsList" @scrollReachBottom="getWater" @click="setParams" id="boxFixed"
		 @touchmove.native="pullDown($event)" :enablePullDownEvent="openPullDown" :style="{transform: contentMove}"
		 @touchstart.native="pullDownStart($event)" :class="ifUp?'moveUpAnimate':''">
			<div slot="waterfall-head" class="jiansh">
				<!--顶部搜索框 -->
				<div class="header backColor">

					<!-- ！！！！！！ 手机端样式 -->
					<!-- 					<van-popup closeable v-model="downloadapp">
						<img style="width: 76%;" @click="skip('http://d.qzq.ink/download/035Z')" src="../../assets/app-download.png" />
					</van-popup> -->
					<!-- ！！！！！！ 手机端样式 -->

					<div style="padding: 0.2rem 0.5rem 0.2rem 0.5rem;">
						<div class="header_center" v-show="showHeader">
							<div class="left" @click="adds=true">
								<span v-if="loaded">{{citys}}</span>
								        <span v-else>定位中..</span>
								<img src="../../assets/xiala.png" alt="">
							</div>
							<div>{{weather.tem}}℃&nbsp;{{weather.wea}}</div>
							<div>{{weather.week}}</div>
							<div>{{time.date}}</div>
							<div>{{time.lunar}}</div>
						</div>
						<van-row type="flex" justify="space-between" align="center">
							<div class="serch_left">
								<img src="../../assets/login.png" alt="">
							</div>
							<van-col span="15">
								<van-search @focus="serch" v-model="value" placeholder="办公桌" shape="round" background="none">
									<div slot="left-icon" class="header_search_left">
										<van-icon name="search" />
									</div>
									<!-- 图片搜索 -->
									<div class="header_search_right" slot="right-icon">
										<van-uploader class="uploader" :after-read="subCamera">
											<img src="../../assets/xiangji.png" alt="">
										</van-uploader>
									</div>
								</van-search>
							</van-col>
							<div class="header_kefu">
								<img src="../../assets/kefu.png" alt="" @click="open53()">
								<div class="marker" v-show="ismarker"><span>{{marker}}</span></div>
							</div>
						</van-row>
						<div class="header_header">
							<div class="styles">
								<span style="font-size:0.8rem;font-weight:bold;border-bottom:2px solid #fff">首页</span>
								<span v-for="item in goodsStyle" @click="goSer(item.id)">{{item.title}}</span>
							</div>
							<router-link to="/class" class="header_icon">
								<img src="../../assets/fenlei.png" alt="">
							</router-link>
						</div>
					</div>
				</div>

				<div class="backgd">
					<!-- 轮播图 -->
					<van-swipe class="home-swipe" :autoplay="3000" indicator-color="#f1452f">
						<van-swipe-item v-for="(image, index) in imgList" :key="index">
							<img :src="image.image | handleUrl" alt="" style="width:100%;height: 100%;object-fit:cover;display:block">
						</van-swipe-item>
					</van-swipe>
				</div>
				<!-- tips -->

				<div class="tips">
					<div>
						<van-icon size="0.9rem" name="passed" />
						<span>正品保证</span>
					</div>
					<div>
						<van-icon size="0.9rem" name="passed" />
						<span>厂家直发</span>
					</div>
					<div>
						<van-icon size="0.9rem" name="passed" />
						<span>全新定制</span>
					</div>
					<div>
						<van-icon size="0.9rem" name="passed" />
						<span>全国联保</span>
					</div>
				</div>

				<!-- <scroller :on-refresh="refresh" style="height:2rem;" refresh-layer-color="red" loading-layer-color="red">
				</scroller> -->

				<!-- 标签栏 -->
				<div class="column">
					<div class="tab" v-for="(item, index) in tabList" :key="index">
						<img :src="item.image" @click="go(item.url)" alt="" style="width:3.1rem;object-fit:cover">
						<div>{{item.title}}</div>
						<span v-if="item.tips != undefined">{{item.tips}}</span>
					</div>
				</div>
				<!-- 成交广告 -->
				<div class="contract">
					<img src="../../assets/tongzhi.png" alt="">
					<van-swipe :autoplay="3500" vertical :touchable="false" :show-indicators="false" style="width:100%;height:100%;">
						<van-swipe-item class="cart_swipe" v-for="item in newList['kx']">{{item.title}}</van-swipe-item>
					</van-swipe>
				</div>
				<!-- 限时抢购 -->
				<div class="flash-sale">
					<div class="flash-sale-title">
						<div class="title-l">
							<img class="iconfont" src="../../assets/purchase.png" />
							<p>限时抢购</p>
							<span>折上再折 一降到底</span>
						</div>
						<div class="title-r">
							<p @click="go('/limit')">查看更多></p>
						</div>
					</div>
					<van-swipe class="my-swipe" :autoplay="5000" indicator-color="white" :show-indicators="false">
						<van-swipe-item v-for="(items,idnex) in product">
							<div class="flash-sale-commodity">
								<div v-for="(item,index) in items" :kay="index" @click='hreftwo(item.id)' style="width: 25%; margin: auto;">
									<div>
										<img :src="item.image | handleUrl" />
										<div class="vip-Price">VIP￥{{item.vip_price}}</div>
									</div>
									<p>￥{{item.price}}</p>
									<van-progress style="margin-top: 0.6rem; width: 80%; margin: auto;" :percentage="item.hundred" stroke-width="5"
									 pivot-text="" pivot-color="transparent" color="#F1452F" />
									<p style="font-size: 12px; color: #666; ">已抢购{{item.hundred}}%</p>
								</div>
							</div>
						</van-swipe-item>
					</van-swipe>
				</div>
				<!-- 推荐产品 -->
				<div v-if="banner.length == 0"></div>
				<div class="hot" v-else>
					<van-swipe :autoplay="3000" class="left" :show-indicators="false">
						<van-swipe-item v-for="item in banner.left">
							<router-link :to="item.url">
								<img :src="item.image | handleUrl" alt="" style="width:100%;height:100%">
							</router-link>
						</van-swipe-item>
					</van-swipe>
					<div class="right">
						<van-swipe :autoplay="4000" :show-indicators="false">
							<van-swipe-item v-for="item in banner.right_top">
								<router-link :to="item.url">
									<img :src="item.image | handleUrl" alt="" style="width:100%;height:100%">
								</router-link>
							</van-swipe-item>
						</van-swipe>
						<van-swipe :autoplay="5000" v-for="item in banner.right_bottom" :show-indicators="false">
							<van-swipe-item>
								<router-link :to="item.url">
									<img :src="item.image | handleUrl" alt="" style="width:100%;height:100%">
								</router-link>
							</van-swipe-item>
						</van-swipe>
					</div>
					<div class="hot-tip">
						<div>广告</div>
					</div>
				</div>
				<!-- 新闻 -->
				<div class="cart">
					<div class="cart_bottom">
						<img src="../../assets/_zhaobiao.png" alt="">
						<van-swipe :autoplay="3500" vertical :touchable="false" :show-indicators="false" style="width:60%;height:100%">
							<van-swipe-item class="cart_swipe" @click="goBidDetail(item.id)" v-for="item in bidList">
								{{item.title}}
							</van-swipe-item>
						</van-swipe>
						<div class="more">
							<router-link to="/bid">
								<span>更多</span>
							</router-link>
						</div>
					</div>
				</div>
				<!-- 图片切片 -->
				<div class="photo_edit" v-if="showPhoto">
					<van-button class="btn_cropper ler_btn" type="warning" size="small" @click="cancleCropper">取消
					</van-button>
					<van-button class="btn_cropper" type="primary" size="small" @click="computeCropper">搜索</van-button>
					<!-- <img :src="photoUrl"> -->
					<vueCropper ref="cropper" :img="photoUrl" :canMoveBox="cropObj.canMoveBox" :outputSize="1" :autoCrop="true"
					 outputType="png" :fixedBox="cropObj.fixedBox" :autoCropWidth="cropObj.width" :autoCropHeight="cropObj.height"
					 :fixedNumber="cropObj.fixedNumber" :fixed="false"></vueCropper>
				</div>
				<!-- 加载状态 -->
				<van-overlay :show="lodImg">
					<div class="wrapper">
						<van-loading color="#fff" size="24px" vertical>加载中...</van-loading>
					</div>
				</van-overlay>
				<!-- 尾部导航 -->
				<div class="bangonglian">
					<van-swipe class="my-swipe" @change="onChange" :autoplay="4500" :duration="1000" indicator-color="#f1452f">
						<van-swipe-item>
							<div class="weibudh" style="width: 100%; height: 100%; ">
								<div style="" v-for="(item, index) in sverList.slice(0,10)" :key="index">
									<img :src="getImg(item.image)" @click="goDetail(item.id)" alt="">
									<p>{{item.title}}</p>
								</div>
							</div>
						</van-swipe-item>
						<van-swipe-item>
							<div class="weibudh" style="width: 100%; height: 100%; ">
								<div style="" v-for="(item, index) in sverList.slice(10,20)" :key="index">
									<img :src="getImg(item.image)" @click="goDetail(item.id)" alt="">
									<p>{{item.title}}</p>
								</div>
							</div>
						</van-swipe-item>
						<van-swipe-item>
							<div class="weibudh" style="width: 100%; height: 100%; ">
								<div v-for="(item, index) in sverList.slice(20,30)" :key="index">
									<img :src="getImg(item.image)" @click="goDetail(item.id)" alt="">
									<p>{{item.title}}</p>
								</div>
							</div>
						</van-swipe-item>
						<template #indicator>
							<div class="lbtzsq">
								<samp class="lbtzsqs" style="background-color:#F1452F;"></samp>
								<samp class="lbtzsqs"></samp>
								<samp class="lbtzsqs"></samp>
							</div>
						</template>
					</van-swipe>
				</div>
				<!-- 租赁方式 -->
				<div class="cart">
					<div class="cart_top">
						<img src="../../assets/buxianshi.png" alt="">
						<img src="../../assets/zuwunian.png" alt="">
					</div>
				</div>
				<div class="hot_bottom">
					<img src="../../assets/_xinwen.png" alt="">
					<van-swipe :autoplay="4500" vertical :touchable="false" :show-indicators="false" style="width:60%;height:100%">
						<van-swipe-item class="cart_swipe" @click="goInform(item.id)" v-for="item in newList['tt']">
							{{item.title}}
						</van-swipe-item>
					</van-swipe>
					<div class="more">
						<router-link to="/newList">
							<span>更多</span>
						</router-link>
					</div>
				</div>
				<!-- 视频专栏 -->
				<div class="videos">
					<video id="myVideo" poster="../../assets/videos.png" class="video-js vjs-default-skin vjs-big-play-centered vjs-fluid">
						<source :src="videoSrc" type="video/mp4">
					</video>
				</div>
				<!-- 横幅 -->
				<div class="streamer">
					<img src="../../assets/hengfu.png" alt="">
				</div>

				<div class="seamless-warp2">
					<vue-seamless-scroll :data="ppList" step=30 :class-option="optionSetting" class="seamless-warp">
						<ul class="item">
							<li v-for="(item,index) in ppList" :key="index">
								<img class="each-img" :src="item.brang_icon | handleUrl" @click="go('/brandDetail',item.id)"></img>
							</li>
						</ul>
					</vue-seamless-scroll>
				</div>
				<!-- 猜您喜欢 -->
				<div class="prefer">
					<div class="title">
						<div class="title-text">
							<span>精品推荐</span>
						</div>
					</div>
					<!-- 图片识别结果 -->
					<van-popup round v-model="select" position="bottom" :style="{ 'height': '85%' }" class="discern">
						<div class="discern-title">
							<div @click="select=false">X</div>
							<div>为您找到以下相似产品</div>
						</div>
						<Waterfall :file="file"></Waterfall>
					</van-popup>
				</div>
			</div>
			<div slot-scope="props">
				<div class="main">
					<p style="font-size: 0.8125rem; color: #000000;">{{props.value.title}}</p>
					<div class="vangrid-right">
						<span class="f1452f">
							<span>租金￥</span>
							<span class="font-5">{{props.value.price[0]}}.</span>
							<span>{{props.value.price[1]}}&nbsp;/月起</span>
						</span>
						<van-icon name="shopping-cart-o" size="14px" color="#fff" />
					</div>
					<div class="vangrid-bottom">
						<div class="gongqi-xing">
							<span v-if="props.value.goods_work == 7">工期7-10天</span>
							<span v-if="props.value.goods_work == 15">工期15-20天</span>
							<span v-if="props.value.goods_work == 30">工期30-40天</span>
							<van-rate size="0.7rem" color="#F1452F" gutter="1px" v-model="props.value.hot_num" readonly />
						</div>
					</div>
				</div>
			</div>
			<div slot="loading" slot-scope="{isFirstLoad}">
				<div v-if="isFirstLoad"></div>
				<div class="firstLoad" v-else="v-else">
					<van-loading size="0.8rem" type="spinner">玩命加载中...</van-loading>
				</div>
			</div>
			<div slot="waterfall-over" class="waterfallOver">
				<van-divider :style="{ color: '#aaa', borderColor:'#aaa', width: '90%'}">我是有底线的</van-divider>
			</div>
		</vue-waterfall-easy>
		<!-- 选择地址 -->
		<van-popup v-model="adds" position="bottom" :style="{ 'height': '95%' }">
			<Adds @close="close" @title="title"></Adds>
		</van-popup>
		<Footbar v-if="isShowFooter"></Footbar>
	</div>
</template>

<script>
	import Footbar from '@/components/footbar'
	import Customerservice from '@/components/customerservice'
	import Adds from '@/components/address'
	import Waterfall from '@/components/waterfall'
	import vueWaterfallEasy from 'vue-waterfall-easy'



	// import MescrollVue from 'import MescrollVue from ‘mescroll.js/mescroll.vue'
	import {
		showDate
	} from '../../assets/js/dates.js'
	import {
		VueCropper
	} from 'vue-cropper'
	import {
		Notify
	} from 'vant';
	export default {
		name: 'home',
		inject: ['reload'],
		data() {
			return {
				saite: [],
				loaded: "",
				isRouterAlive: true,
				moveTime: 0, // 记录滚动事件触发次数
				pullStart: 0, // 首次移动的初始Y轴位置
				pullMove: 0, // 移动后当前点Y轴位置
				ifUp: false,
				listt: [],
				moveTop: -50 + "px", // 下拉刷新移动距离
				ifReload: "下拉刷新",
				chenggong: "刷新成功",
				jiazaicheng: "加载成功",
				// 下拉刷新字样
				openPullDown: true, // 开启下拉刷新
				contentMove: "translate3d(0px, '+ 0 +'px, 0px)",
				gundon: "",
				showHeader: true,
				value: '',
				sverList: [],
				isShowFooter: true,
				showPhoto: false,
				photoUrl: '',
				cropObj: {
					width: 340,
					height: 340,
					fixedBox: true,
					fixedNumber: [1, 1],
					canMoveBox: false
				},
				isFixed: false,
				activeCls: 'active', //当isActive值为true时，会执行activeCls对应的样式 active 并且执行baseClass对应的样式 baseclass
				errorCls: 'error', //当isActive值为false时，会执行errorCls对应的样式 error 并且执行baseClass对应的样式 baseclass
				baseClass: 'baseclass',
				insql: true,
				offsetTop: 0,
				lodImg: false,
				show: true,
				ismarker: false,
				marker: 0,
				current: 0,
				loginPopupShowL: false,
				//轮播图
				imgList: [],
				//标签栏
				tabList: [{
					image: require('../../assets/zu.gif'),
					title: '以租代购区',
					url: '/home_class?category_id=1',
					tips: '省'
				}, {

					image: require('../../assets/gou.gif'),
					title: '限时抢购区',
					url: '/limit',
					tips: '抢'
				}, {
					image: require('../../assets/ershou.gif'),
					title: '精品二手区',
					url: '/home_class?category_id=3'
				}, {
					image: require('../../assets/zhengzu.gif'),
					title: '整装整租',
					url: '/packages',
					tips: '新'
				}, {
					image: require('../../assets/zimao.gif'),
					title: '闲具自贸区',
					url: '/home_undete?type=1'
				}, {
					image: require('../../assets/toubiao.png'),
					title: '招标投标',
					url: '/bid'
				}, {
					image: require('../../assets/zaixian.png'),
					title: '方案获取',
					url: '/design'
				}, {
					image: 'https://backstage.jbj-china.com.cn/image/img/qita.gif',
					title: '办公链',
					url: '/home_sever'
				}],
				//推荐产品
				banner: [],
				//视频资源
				videoSrc: 'https://backstage.jbj-china.com.cn/videos/oceans.mp4',
				//品牌栏图片
				ppList: [],
				//商品列表
				leftItems: [],
				rightItems: [],
				//搜索列表
				discern: [],
				goodsStyle: [], //风格列表
				newList: [],
				bidList: [],
				city: '',
				jshajsj: true,
				select: false, //图片识别结果,
				adds: false, //地址选择
				weather: {}, //天气信息,
				loding: false,
				imgsArr: [],
				pages: 1,
				file: '',
				lat: '',
				lng: '',
				province: '',
				city: '',
				district: '',
				citykois: '',
				chengshi: '',
				fodatawe: '',
				goddsList: [],
				formattedAddress: '', //默认城市
				product: [],
				downloadapp: true, //下载APP弹窗
				time: '' //时间
			}
		},

		components: {
			Footbar,
			VueCropper,
			Notify,
			vueWaterfallEasy,
			Waterfall,
			Adds,
			Customerservice,
		},
		computed: {
			optionSetting() {
				return {

					step: 0.6, // 数值越大速度滚动越快

					limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length

					hoverStop: false, // 是否开启鼠标悬停stop

					direction: 2, // 0向下 1向上 2向左 3向右

					openWatch: true, // 开启数据实时监控刷新dom

					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1

					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3

					waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
				}
			},
		},
		activated() {
			this.getData();
			this.getWater(this.pages);
			// this.htmlFontSize();

		},
		mounted() {
			AMap.service(["AMap.Geolocation", "AMap.CitySearch"], () => {
				const geolocation = new AMap.Geolocation({
					enableHighAccuracy: true, //是否使用高精度定位，默认:true
					timeout: 5000 //超过5秒后停止定位，默认：无穷大
				});
				//  获取位置信息
				geolocation.getCurrentPosition((status, result) => {
					if (result && result.position) {
						this.$store.state.location[0] = result.position.lng;
						this.$store.state.location[1] = result.position.lat;
						this.loaded = true;
						if (result.addressComponent.city) {
							this.citys = result.addressComponent.city;

						} else {
							this.citys = result.addressComponent.province;

						}
						this.$nextTick();
					}
				});
			});
			this.initVideo();
			window.addEventListener('scroll', this.hanldScroll);
		},
		watch: {
			gundon: {
				handler(newName, oldName) {
					if (newName > oldName) {

						this.showHeader = false;
					} else if (newName < 500) {
						this.showHeader = true;
					}
				}
			},
			//取出
			'$route'(to, from) {
				//判断一下第一次进是由a到b页面才刷新 从其他页面进入不刷新
				if (to.name === 'home') { //跳转的的页面的名称是"NewRecruit",这里就相当于我们listview页面，或者原始页面
					let screenYAll = this.$store.state.screenY

					//把在vuex里面的位置存入
					document.getElementsByClassName("vue-waterfall-easy-scroll")[0].scrollTop = screenYAll
				}
			}

		},
		// 存路由
		beforeRouteLeave(to, from, next) {
			//获取滚动条的高度
			let position = document.getElementsByClassName("vue-waterfall-easy-scroll")[0].scrollTop
			//离开路由存起来
			if (position == null) position = 0
			this.$store.commit('screenYAll', position) //离开路由时把位置存起来
			next()
		},
		methods: {
			// 办公连轮播图指示器
			onChange(index) {
				this.current = index;
				var lbtzsqs = document.getElementsByClassName("lbtzsqs")
				for (var i = 0; i < lbtzsqs.length; i++) {
					lbtzsqs[i].style.background = "#f2f2f2"
					lbtzsqs[index].style.background = "#F1452F"
				}

			},
			//下拉刷新
			refresh(done) {
				setTimeout(() => {
					this.pages = 1;
					this.getWaterr(this.pages)
					this.$toast("刷新完成")
					done()
				}, 1500)
			},
			// 跳转办公连详情
			goDetail(id) {
				if (!id) {
					this.$router.push({
						path: '/home_sever',
					})
				} else {
					this.$router.push({
						path: '/ser_detail',
						query: {
							id: id
						}
					})
				}
			},
			// 开始滚动
			pullDown(e) {
				var then = this;
				then.gundon = document.getElementsByClassName('vue-waterfall-easy-scroll')[0].scrollTop;
			},
			pullDownStart(e) {
				this.moveTime = 0;
			},
			//选择地址
			title(e) {
				this.citys = e;
			},
			//关闭地址选择
			close(e) {
				this.adds = e;
			},
			getImg(url) {
				return baseUrl + '/uploads' + url;
			},
			//商品列表
			getWater() {
				var self = this
				self.$axios.post(baseUrl + '/mobile/Goods/goodsList', {
					page: self.pages
				}).then((res) => {
					if (res.data.code == 2) {
						for (let v of res.data.data) {
							var picObj = {
								"src": "https://backstage.jbj-china.com.cn/uploads/"
							}
							picObj["src"] += v.image;
							picObj["title"] = v.title;
							picObj["price"] = Number(v.price).toFixed(2).split(".");
							picObj["hot_num"] = v.hot_num;
							picObj["goods_work"] = v.goods_work;
							picObj["id"] = v.id;
							self.imgsArr = self.imgsArr.concat(picObj);
							// self.kongye = res.data.data;           
						}
						self.goddsList = self.imgsArr,
							self.pages++;
					} else {
						self.$refs.waterfall.waterfallOver();
					}
				}).catch((res) => {

				});
			},

			//下拉刷新
			getWaterr(pages) {
				var self = this
				self.$axios.post(baseUrl + '/mobile/Goods/goodsList', {
					page: pages
				}).then((res) => {
					if (res.data.code == 2) {
						self.imgsArr = []
						for (let v of res.data.data) {

							var picObj = {
								"src": "https://backstage.jbj-china.com.cn/uploads/"
							}
							picObj["src"] += v.image;
							picObj["title"] = v.title;
							picObj["price"] = v.price;
							picObj["hot_num"] = v.hot_num;
							picObj["goods_work"] = v.goods_work;
							picObj["id"] = v.id;
							self.imgsArr = self.imgsArr.concat(picObj);
							// self.kongye = res.data.data;           
						}
						self.goddsList = self.imgsArr
					} else {
						self.$refs.waterfall.waterfallOver();
					}
				}).catch((res) => {

				});
			},
			rmkf() {
				console.log(1)
				div.removeChild = newObj;
				div.removeChild = div2;
			},

			//跳转详情页
			setParams(event, {
				index,
				value
			}) {
				event.preventDefault()
				// 只有当点击到图片时才进行操作
				if (event.target.tagName.toLowerCase() == 'img') {
					this.$router.push({
						path: '/Detail',
						query: {
							id: value.id
						}
					})
				}
			},
			showDate,
			//截取农历日期
			getCaption(obj) {
				var index = obj.lastIndexOf("\年");
				obj = obj.substring(index + 2, obj.length);
				return obj;
			},
			//53客服
			_open53() {
				this.ismarker = false;
				this.marker = 0;
				let _53 = $53.createApi();
				_53.push('cmd', 'mtalk');
				_53.query();
			},
			getData() {

				// 办公连数据
				this.$axios.post(baseUrl + '/mobile/Category/thirdparty')
					.then((res) => {
						if (res.data.code == 2) {
							res.data.data[0].category.pop()
							res.data.data[1].category.pop()
							this.sverList = this.sverList.concat(res.data.data[0].category)
							this.sverList = this.sverList.concat(res.data.data[1].category)
							this.sverList = this.sverList.concat(res.data.data[2].category)
							this.sverList.splice(25, 3)
							this.sverList[29].title = "查看全部"
							this.sverList[29].id = ""
						}
					}).catch((err) => {
						console.log(err);
					});
				//天气
				this.getJSON('https://v0.yiketianqi.com/api', {
					version: 'v61',
					appid: 55555583,
					appsecret: 'ZdTyGSD9'
				}, (res) => {
					this.weather = res;
				});
				//轮播图
				this.$axios.post(baseUrl + '/mobile/Index/banner', {
					category_id: 0
				}).then((res) => {
					if (res.data.code == 2) {
						this.imgList = res.data.data;
					}
				}).catch((err) => {

				});
				//获取时间
				this.$axios.post(baseUrl + '/mobile/get_date/getDate').then((res) => {
					this.time = res.data
					console.log(this.time)
				}).catch((err) => {

				});
				// 首页限时抢购数据
				this.$axios.post(baseUrl + '/mobile/Limit_Goods/limitGoods', {
					page: 1,
					limit: 3,
					cat_id: -1
				}).then(res => {
					if (res.data.code == 2) {
						var a = [res.data.data.slice(0, 4), res.data.data.slice(4, 8), res.data.data.slice(8, 12), res.data.data
							.slice(12, 16)
						]
						for (var i = 0; i < a.length; i++) {
							if (a[i].length == 4) {
								this.product.push(a[i])
							}
						}
					}
				});

				//品牌
				this.$axios.post(baseUrl + '/mobile/Index/brand')
					.then((res) => {
						if (res.data.code == 2) {
							this.ppList = res.data.data;
						}
					}).catch((err) => {

					});
				//广告
				this.$axios.post(baseUrl + '/mobile/Index/advertisement', {
					city: this.city
				}).then((res) => {
					if (res.data.code == 2) {
						this.banner = res.data.data;
					}
				}).catch((err) => {

				});
				//风格分类
				this.$axios.post(baseUrl + '/mobile/Category/goodsCategory')
					.then((res) => {
						if (res.data.code == 2) {
							this.goodsStyle = res.data.data.style;
						}
					}).catch((err) => {

					});
				//招标公告
				this.$axios.post(baseUrl + '/mobile/Base/bid', {
					id: 1,
					limit: 5,
					page: 1
				}).then((res) => {
					if (res.data.code == 2) {
						this.bidList = res.data.data;
					}
				}).catch((err) => {
					console.log(err);
				});
				//新闻列表
				this.$axios.post(baseUrl + '/mobile/Base/news', {
					limit: 5,
					page: 1
				}).then((res) => {
					if (res.data.code == 2) {
						this.newList = res.data.data;
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			initVideo() {
				//初始化视频方法
				let myPlayer = this.$video(myVideo, {
					//确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
					controls: true,
					//自动播放属性,muted:静音播放
					autoplay: false,
					//建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
					preload: "auto",
					//设置视频播放器的显示宽度（以像素为单位）
					width: "100%",

					//设置视频播放器的显示高度（以像素为单位）
					height: "100%"
				});
			},
			hreftwo(id) {
				this.$router.push({
					path: '/limitDetail',
					query: {
						id: id,
						cart_id: -1
					}
				})
			},
			//标签跳转
			go(url, id) {
				this.$router.push({
					path: url,
					query: {
						id: id
					}
				})
			},
			//风格详情
			goSer(style_id) {
				this.$router.push({
					path: '/serClass',
					query: {
						style_id: style_id
					}
				})
			},
			//中标详情
			goBidDetail(id) {
				this.$router.push({
					path: '/bidDetail',
					query: {
						id: id
					}
				})
			},
			// 跳转页面
			skip(url) {
				window.location.href = url
			},
			// 
			// guanbi() {
			// 	this.downloadapp = false
			// },
			// 新闻详情
			goInform(id) {
				this.$router.push({
					path: '/information',
					query: {
						id: id
					}
				})
			},
			blobToDataURI(blob, callback) {
				var reader = new FileReader();
				reader.onload = function(e) {
					callback(e.target.result);
				}
				reader.readAsDataURL(blob);
			},
			// 取消截图
			cancleCropper() {
				this.showPhoto = false;
			},
			// 裁剪图片
			computeCropper() {
				let _this = this;
				if (this.$refs.cropper.cropW < 200) {
					this.$refs.cropper.cropW = 200;
					this.$refs.cropper.cropH = 200;
					this.$refs.cropper.cropR
					this.$toast({
						icon: 'none',
						message: '请截取200x200以上的图片',
						duration: 2500

					});
					return;
				}
				this.$refs.cropper.getCropData((file) => {
					// data切片后的blob
					// 切片后的路径
					// this.newPthot = window.URL.createObjectURL(data)
					// 切片后的file
					// 此处向后端传递切片好的文件
					_this.showPhoto = false;
					_this.select = true;
					_this.loding = false;
					_this.file = file;
				})
			},
			//拍照上传
			subCamera(file) {
				this.showPhoto = true;
				this.photoUrl = file.content
			}
		},
		//回调中移除监听
		destroyed() {
			window.removeEventListener('scroll', this.handleScroll)
		},

	}
</script>

<style scoped>
	@import 'home.css';

	@keyframes fade-in {
		0% {
			opacity: 0;
		}

		/*初始状态 透明度为0*/
		40% {
			opacity: 1;
		}

		/*过渡状态 透明度为0*/
		100% {
			opacity: 1;
		}

		/*结束状态 透明度为1*/
	}

	@-webkit-keyframes fade-in {

		/*针对webkit内核*/
		0% {
			opacity: 0;
		}

		40% {
			opacity: 1;
		}

		100% {
			opacity: 1;
		}
	}

	@keyframes fadee-sn {
		0% {
			opacity: 1;
		}

		/*初始状态 透明度为0*/
		40% {
			opacity: 1;
		}

		/*过渡状态 透明度为0*/
		100% {
			opacity: 0;
		}

		/*结束状态 透明度为1*/
	}

	@-webkit-keyframes fadee-sn {

		/*针对webkit内核*/
		0% {
			opacity: 1;
		}

		40% {
			opacity: 1;
		}

		100% {
			opacity: 0;
		}

	}

	.qizi {
		transform: scale(0.8);
		color: red;
		position: relative;
		padding-top: 0.25rem;
		/* top: 0.1rem; */
		/* margin-right: 1.2rem; */
		/* position: relative;
    left: -1.1rem;
    top: 0.1rem; */

	}

	/* 当滚动条为ture的时候 */
	.active {
		position: fixed;
		top: 2rem;
		display: none !important;
		z-index: 999;
		/* -webkit-animation-name: fadee-sn;
-webkit-animation-duration:5s;
-webkit-animation-iteration-count: 1;
-webkit-animation-delay:0s */
		/* animation: fade-in; 
    animation-duration: 5s;
    -webkit-animation:fade-in 1.5s; */

	}

	/* 当滚动条为flase的时候 */
	.error {
		/* position: fixed; */
		top: 2rem;
		z-index: 999;
		-webkit-animation-name: fade-in;
		-webkit-animation-duration: 5s;
		-webkit-animation-iteration-count: 1;
		-webkit-animation-delay: 0s;
	}

	#clasdaa {
		overflow: hidden !important;
	}

	html,
	body,
	#app {
		overflow: hidden !important;
	}

	#boxFixed>>>.van-row--align-center {
		height: 2.6rem;
		-webkit-overflow-scrolling: touch !important;

	}

	#boxFixed>>>.van-search__content--round {
		margin-top: 0.5rem;
		-webkit-overflow-scrolling: touch !important;
	}

	#boxFixed {
		-webkit-overflow-scrolling: touch !important;
	}

	.jiansh {
		overflow-x: hidden !important;
		overflow-y: hidden !important;
	}

	.van-overlay {
		z-index: 8888 !important;
	}

	.van-dialog {
		z-index: 9999 !important;
	}

	/* .f1452f span:nth-child(4) {
      position: absolute;
      transform: scale(0.8);
   } */

	.van-button--large {
		width: 80%;
		color: #fff;
		background: #F1452F;
		height: 2rem;
		line-height: 2rem;
		border-radius: 1rem;
		margin: 1rem 0;
		font-size: 0.9rem;
	}

	.home .van-popup {
		background-color: transparent;
		width: 100%;
	}

	.discern {
		z-index: 3000 !important;
		background: #f5f6f8;
		border-radius: 0.5rem 0.5rem 0 0;
	}

	.wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}

	.photo_edit {
		width: 100%;
		height: 100%;
		position: fixed;
		background-color: rgba(0, 0, 0, .9);
		z-index: 2000;
		top: 0;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.photo_edit /deep/ .vue-cropper {
		background-image: none;
	}


	.photo_edit img {
		width: 100%;
	}

	.btn_cropper {
		position: fixed;
		right: 2rem;
		top: 3rem;
		width: 60px;
		z-index: 2000;
	}

	.ler_btn {
		left: 2rem;
	}

	.home .header .styles {
		margin-top: -0.5rem !important;
	}

	.home .header .header_icon img {
		margin-top: -0.6rem !important;

	}

	body::-webkit-scrollbar {
		display: none
	}

	.pullDown {
		position: absolute;
		top: -3rem;
		left: 0;
		width: 100%;
		text-align: center;

	}

	.pullDown p {
		color: #c8c9cc;
		font-size: 14px;
		padding: 20px 0;
		width: 100%;
	}

	.moveUpAnimate {
		transition: 200ms ease all;
		-webkit-transition: 200ms ease all;
	}

	#clasdaa>>>._v-container>._v-content>.pull-to-refresh-layer[data-v-ecaca2b0] {
		width: 100%;
		height: 60px;
		margin-top: -20px;
		text-align: center;
		font-size: 16px;
		color: #aaa;
	}

	.no-data-textno-data-text {
		background-image: url(../../assets/3.jpg);
		box-sizing: 100% 100%;
	}

	.gongqi-xing {
		display: flex;
		justify-content: space-between;
	}

	.home .header .styles::-webkit-scrollbar {
		display: none;
	}

	.gongqi-xing>>>.van-rate--readonly {
		position: relative;
		top: 0.15rem;
	}

	.bangonglian {
		width: 94%;
		margin: auto;
		background-color: #fff;
		border-radius: 0.3rem;
		padding-top: 1rem;
		padding-bottom: 0.6rem;
	}

	.my-swipe {
		display: flex;
	}

	.weibudh>div {
		display: inline-block;
		height: 4.2rem;
		width: 20%;
	}

	.weibudh>div>img {
		display: block;
		width: 2.3rem;
		object-fit: cover;
		border-radius: 50%;
		margin: auto;
	}

	.weibudh>div>p {
		display: block;
		width: 4rem;
		font-size: 0.75rem;
		color: #262626;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		text-align: center;
		margin: auto;
		margin-top: 0.5rem;
	}

	.lbtzsq {
		width: 45%;
		height: 0.3rem;
		position: absolute;
		bottom: 0;
		left: 50%;
		display: flex;
		justify-content: space-between;
		transform: translateX(-50%);
	}

	.lbtzsq samp {
		display: flex;
		width: 3rem;
		height: 0.15rem;
		background-color: #f2f2f2;
		border-radius: 5px;
	}

	/* #boxFixed >>> .vue-waterfall-easy-container .vue-waterfall-easy-scroll[data-v-ded6b974]{
       overflow-y: auto;
} */
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue